import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { numberConvert } from "@website/utils/number-convert";
import { useEffect } from "react";
export const useCounterButton = properties => {
  const $ = _c(35);
  const {
    color,
    decreaseDisabled,
    increaseDisabled,
    onChange,
    value: t0,
    variant,
    locale,
    "aria-label": ariaLabel
  } = properties;
  const value = t0 === undefined ? 0 : t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = () => {
      onChange?.(value - 1);
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDecreaseButtonClick = t1;
  let t2;
  if ($[3] !== onChange || $[4] !== value) {
    t2 = () => {
      onChange?.(value + 1);
    };
    $[3] = onChange;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onIncreaseButtonClick = t2;
  let t3;
  let t4;
  if ($[6] !== onChange || $[7] !== value) {
    t3 = () => {
      if (value === undefined) {
        onChange?.(0);
      }
    };
    t4 = [onChange, value];
    $[6] = onChange;
    $[7] = value;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== locale || $[11] !== value) {
    t5 = numberConvert(value, {
      locale: locale || "en"
    }) || 0;
    $[10] = locale;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = ariaLabel ? `${"\u06A9\u0627\u0647\u0634"} ${ariaLabel}` : "decrease button";
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MaterialIcon name="remove" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== color || $[16] !== decreaseDisabled || $[17] !== onDecreaseButtonClick || $[18] !== t7 || $[19] !== variant) {
    t9 = {
      "aria-label": t7,
      color,
      disabled: decreaseDisabled,
      EndIcon: t8,
      onClick: onDecreaseButtonClick,
      equalDimension: true,
      variant
    };
    $[15] = color;
    $[16] = decreaseDisabled;
    $[17] = onDecreaseButtonClick;
    $[18] = t7;
    $[19] = variant;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = ariaLabel || undefined;
  let t11;
  if ($[21] !== t10) {
    t11 = {
      "aria-label": t10
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = ariaLabel ? `${"\u0627\u0641\u0632\u0627\u06CC\u0634"} ${ariaLabel}` : "increase button";
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <MaterialIcon name="add" />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== color || $[25] !== increaseDisabled || $[26] !== onIncreaseButtonClick || $[27] !== t12 || $[28] !== variant) {
    t14 = {
      "aria-label": t12,
      color,
      disabled: increaseDisabled,
      EndIcon: t13,
      onClick: onIncreaseButtonClick,
      equalDimension: true,
      variant
    };
    $[24] = color;
    $[25] = increaseDisabled;
    $[26] = onIncreaseButtonClick;
    $[27] = t12;
    $[28] = variant;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t11 || $[31] !== t14 || $[32] !== t5 || $[33] !== t9) {
    t15 = {
      value: t5,
      rootProps: t6,
      decreaseButtonProps: t9,
      valueProps: t11,
      increaseButtonProps: t14
    };
    $[30] = t11;
    $[31] = t14;
    $[32] = t5;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};